import { EABFilterImplementationType, type FilterOption, SQDCBoardEventStatus } from "@/graphql";
import type { EventFilter } from "../FilterTypes";
import BoardOriginFilterUI from "../ui/BoardOriginFilterUI.vue";
import BoardOriginFilterBadge from "../ui/badges/BoardOriginFilterBadge.vue";

export default class BoardOriginFilter implements EventFilter {
  constructor(
    public readonly boardOrigin: SQDCBoardEventStatus,
    public readonly isNegated?: boolean,
  ) {}

  static readonly UI = BoardOriginFilterUI;

  static readonly Badge = BoardOriginFilterBadge;

  getEventFilter(): FilterOption {
    return {
      filter: {
        type: EABFilterImplementationType.EVENT_BOARD_ORIGIN,
        value: {
          value: [this.boardOrigin],
          negated: this.isNegated ?? false,
        },
      },
    };
  }
}
